/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatisticsValue
 */
export interface StatisticsValue {
    /**
     * 
     * @type {number}
     * @memberof StatisticsValue
     */
    date?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsValue
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof StatisticsValue
     */
    info?: string;
}

/**
 * Check if a given object implements the StatisticsValue interface.
 */
export function instanceOfStatisticsValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatisticsValueFromJSON(json: any): StatisticsValue {
    return StatisticsValueFromJSONTyped(json, false);
}

export function StatisticsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'info': !exists(json, 'info') ? undefined : json['info'],
    };
}

export function StatisticsValueToJSON(value?: StatisticsValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'value': value.value,
        'info': value.info,
    };
}

